angular.module('bribac.views.editSchedulePeriod', [
  'ngRoute',
  'bribac.entities.kinds',
  'bribac.services.routeAuth',
  'bribac.services.api',
  'bribac.components.whenLoaded',
  'bribac.components.schedulePeriodEditor'
])

  .config(function(
    $routeProvider
  ) {
    $routeProvider.when('/schedule-period/:id/edit', {
      templateUrl: 'edit-schedule-period-view.html',
      controller: 'EditSchedulePeriodViewCtrl',
      controllerAs: '$ctrl',
      resolve: {access: function(routeAuth) {return routeAuth.requireAuth()}}
    })
  })

  .controller('EditSchedulePeriodViewCtrl', function(
    $routeParams,
    $location,
    KINDS,
    api,
    schedulePeriodFactory
  ) {

    var $ctrl = this

    var id = parseInt($routeParams.id)

    if (!isFinite(id)) {
      // TODO: Should show 404 error instead. Should probably do this check in the $routeProvider config.
      return
    }

    function navigateToSubject() {
      $location.url('/subject/' + $ctrl.schedulePeriod.subject.id)
    }

    $ctrl.successCallback = navigateToSubject
    $ctrl.cancelCallback = navigateToSubject

    // Init

    $ctrl.schedulePeriodPromise = api.get(KINDS.SCHEDULE_PERIOD, id).then(function(request) {
      $ctrl.schedulePeriod = request.data
      $ctrl.editableSchedulePeriod = angular.copy($ctrl.schedulePeriod)
      $ctrl.headingData = {
        schedulePeriod: $ctrl.schedulePeriod.schedule.name,
        subject: $ctrl.schedulePeriod.subject.fullName,
      }
    })

  })
